import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter, HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { LMFieldBaseComponent } from '@field/lm-field-base.component';
import { LMModel, LMModelChangedEvent } from '@form/model';
import { LMFieldServiceAdapter } from '@field/lm-field-service-adapter';
import { SohoRatingComponent } from 'ids-enterprise-ng';

@Component({
  selector:    'lm-rating',
  templateUrl: './lm-rating.component.html',
  styleUrls:   [ 'lm-rating.component.scss' ]
})
export class LMRatingComponent extends LMFieldBaseComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() layoutObject: LMFormLayoutField;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;

  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  @ViewChild('sohoRating') private rating: SohoRatingComponent;

  @HostBinding('attr.data-automation-id') get dataFieldAutomationId() {
    return `lm-${this.fieldAutomationId}-field`;
  }

  public ratingOptions: Array<LMStarRatingOption>;
  public ratingName: string;

  private initialValue: any;

  constructor(
    protected lmFieldServiceAdapter: LMFieldServiceAdapter,
    private elementRef: ElementRef) {
    super(lmFieldServiceAdapter);
  }

  // events
  ngOnInit() {
    super.ngOnInit();
    this.initialize(this.layoutObject, this.specFields, this.model);
    this.ratingOptions = this.lmFieldServiceAdapter.lmFormatUtilService.formatStarRatingOptions(this.modelField.value, this.id);
    this.ratingName = this.id + '_rating_name'
    this.initialValue = this.modelField.value;

    // Need to set vertical align on the parent element, or the form paragraph layout messes up
    const parentNode = this.lmFieldServiceAdapter.renderer2.parentNode(this.elementRef.nativeElement);
    if (parentNode) {
      this.lmFieldServiceAdapter.renderer2.setStyle(parentNode, 'vertical-align', 'bottom');
    }

    this.subscriptionArray.push(this.model.modelChanged
      .subscribe((modelChangedEvent: LMModelChangedEvent) => {
        if (modelChangedEvent.eventType === 'set') {
          // Need to make sure the control's current value matches the value that has been set after a save action.
          // if not, the control gets confused, and we can't change the value after saving
          if (this.modelField.value !== this.initialValue) {
            this.rating.currentValue = this.modelField.value;
          }
          if (this.isReadOnly || this.displayAsText) {
            this.rating.readonly();
          }
          this.initialValue = this.modelField.value;
          this.onPristine(null);
        }
      })
    );
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();

    if ((this.isReadOnly || this.displayAsText) && this.rating) {
      this.rating.readonly();
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  /**
   * Handles the onChange event from clicking a star. This will set the modelField.value and set the field as
   * dirty. Currently we don't track the initial value so we don't reset pristine if the user attempts to select
   * the initial star value again
   *
   * @param event - click event from the DOM
   */
  public onChangeRating(event: Event) {
    const newValue = this.rating.currentValue;

    this.modelField.toDataValue(newValue, this.transformOptions);

    if (newValue === this.initialValue) {
      this.onAfterResetDirty(event as any);
    } else {
      this.onDirty(event as any);
    }
  }
}
